import moment from 'moment'
import React, { useState } from 'react'
import ReactDatePicker from 'react-datepicker'
import { Label } from 'reactstrap'
import { handleDate } from '../../../../utils/commonFunctions'
import { RadioContainer } from '../../../commons'
import { CalenderIcon } from '../../../Icon'

type RadioTypes = {
  id: string;
  name: string;
};
type AppProps = {
  formError: any;
  setFormError: (data: any) => void;
  setInputDetails: (data: any) => void;
  setVatTaxRadioValue: (data: any) => void;
  inputDetails:any;
  vatTaxRadioValue:string;
}

const TAX_RADIO_OPTIONS: RadioTypes[] = [
  {
    id: 'taxable',
    name: 'Taxable'
  },
  {
    id: 'exempted',
    name: 'Exempted'
  },
]

const VatDetails = ({
  formError,
  setFormError,
  setInputDetails,
  inputDetails,
  setVatTaxRadioValue,
  vatTaxRadioValue
}: AppProps) => {
  const [startDate, setStartDate] = useState("");

  // const handleStartDateChange = (date: any) => {
  //   const value = handleDate(date);
  //   setStartDate(value);
  // };

  const handleSetVatRadioValue = (value: string) => {
    setVatTaxRadioValue(value)
    if (value === 'exempted') {
      setFormError((prev: any) => ({
        ...prev,
        taxRateError: ''
      }))
      setInputDetails((prev: any) => ({
        ...prev,
        vatTaxType:'Exempt',
        vatTaxRate: 0
      }))
    }
    else {
      setInputDetails((prev: any) => ({
        ...prev,
        vatTaxType:'Taxable',
        vatTaxRate:''
      }))
    }
  }

  const handleVatDetailsChange = (e: any) => {
    const Name = e.target.name;
    const Value = e.target.value;
    if (Name === 'taxRate') {
      if (Value>=0) {
        setFormError((prev: any) => ({
          ...prev,
          taxRateError: ''
        }))
        setInputDetails((prev: any) => ({
          ...prev,
          vatTaxType: 'Taxable',
          vatTaxRate: Value
        }))
      }
    }
  }
  return (
    <>
      <div className="col-md-12">
        <div className="row" style={{ marginTop: '10px' }}>
          <div className="col-md-4">
            <h4>Tax Type :</h4>
            <div className="mt-3 mb-4">
              <RadioContainer
                optionsList={TAX_RADIO_OPTIONS}
                handleSetRadioValue={handleSetVatRadioValue}
                radioValue={vatTaxRadioValue}
              />
            </div>
          </div>
        </div>
        <h4>VAT Details :</h4>

        <div className='row'>
          <div className="col-md-4">
            <form>
              <div className="form-group mt-3">
                <div>
                  <label htmlFor="TAXRATE"
                  >Tax Rate*</label>
                  <input
                    type="number"
                    className={`form-control ${!!formError.taxRateError ? "error-border" : null}`}
                    name="taxRate"
                    value={inputDetails?.vatTaxRate}
                    onChange={(e) => handleVatDetailsChange(e)}
                    disabled={inputDetails?.vatTaxType==='Exempt'?true:false}
                    onWheel={event => event.currentTarget.blur()}
                  />
                  {!!formError.taxRateError && (
                    <small className="text-danger">{formError.taxRateError}</small>
                  )}
                </div>
              </div>
            </form>
          </div>
          {/* future purpose */}

          {/* <div className="col-md-4" style={{ marginTop: '40px' }}>
            <div className="form-group">
              <div className='date-picker-wraper mr-0'>
                <Label className='m-0 p-0 w-100'>
                  <ReactDatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={startDate ? new Date(moment(`${startDate}T00:00:00`, 'YYYY-MM-DD').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                    onChange={(e: any) => { handleStartDateChange?.(moment(e).format('YYYY-MM-DD')) }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    name='dateOfInvoice'
                    placeholderText='choose effective date'
                    className='form-control'
                    disabled
                  />
                  <span className="calender-icon" style={{ right: '30px', cursor: 'pointer' }}>
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </>
  )
}

export default VatDetails